import { render, staticRenderFns } from "./contract-xs-detaili.vue?vue&type=template&id=69ef484f&scoped=true"
import script from "./contract-xs-detaili.vue?vue&type=script&lang=js"
export * from "./contract-xs-detaili.vue?vue&type=script&lang=js"
import style0 from "./contract-xs-detaili.vue?vue&type=style&index=0&id=69ef484f&prod&lang=css"
import style1 from "./contract-xs-detaili.vue?vue&type=style&index=1&id=69ef484f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ef484f",
  null
  
)

export default component.exports